export const InquiryType = {
  INQUIRY_TYPE_DEFAULT: 0,
  INQUIRY_TYPE_COURSE_BOOKING: 1,
  INQUIRY_TYPE_COURSE_INQUIRY: 2,
  INQUIRY_TYPE_COURSE_INQUIRY_WITHOUT_DATE: 3,
  INQUIRY_TYPE_EDUCATION_INQUIRY: 4,
  INQUIRY_TYPE_EDUCATION_INQUIRY_WITHOUT_DATE: 5,
  INQUIRY_TYPE_CITY_CONTACT_INQUIRY: 6,
  INQUIRY_TYPE_APPLICATION_INQUIRY: 7,
  INQUIRY_TYPE_COMPANY_COURSE_INQUIRY: 8,
  INQUIRY_TYPE_RETRAINING_INQUIRY: 9,
  INQUIRY_TYPE_RETRAINING_INQUIRY_WITHOUT_DATE: 10,
  INQUIRY_TYPE_COMPLAINT_INQUIRY: 11,
  INQUIRY_TYPE_SAP_CERTIFICATION_INQUIRY: 12,
  INQUIRY_TYPE_BFD_CONTACT_INQUIRY: 13,
  INQUIRY_TYPE_CHECKOUT_BOOKING: 14,
};

export const InquiryTypes = [
  { id: InquiryType.INQUIRY_TYPE_DEFAULT, name: 'Default' },
  { id: InquiryType.INQUIRY_TYPE_COURSE_BOOKING, name: 'Buchung' },
  {
    id: InquiryType.INQUIRY_TYPE_COURSE_INQUIRY,
    name: 'Anfrage mit Datum',
  },
  {
    id: InquiryType.INQUIRY_TYPE_COURSE_INQUIRY_WITHOUT_DATE,
    name: 'Anfrage ohne Datum',
  },
  {
    id: InquiryType.INQUIRY_TYPE_EDUCATION_INQUIRY,
    name: 'Anfrage für geförderte Weiterbildung',
  },
  {
    id: InquiryType.INQUIRY_TYPE_EDUCATION_INQUIRY_WITHOUT_DATE,
    name: 'Anfrage für geförderte Weiterbildung ohne Datum',
  },
  {
    id: InquiryType.INQUIRY_TYPE_CITY_CONTACT_INQUIRY,
    name: 'Allgemeine Anfrage',
  },
  {
    id: InquiryType.INQUIRY_TYPE_APPLICATION_INQUIRY,
    name: 'Online Bewerbung',
  },
  {
    id: InquiryType.INQUIRY_TYPE_COMPANY_COURSE_INQUIRY,
    name: 'Anfrage Firmenkurs',
  },
  {
    id: InquiryType.INQUIRY_TYPE_RETRAINING_INQUIRY,
    name: 'Umschulung',
  },
  {
    id: InquiryType.INQUIRY_TYPE_RETRAINING_INQUIRY_WITHOUT_DATE,
    name: 'Umschulung Anfrage',
  },
  {
    id: InquiryType.INQUIRY_TYPE_COMPLAINT_INQUIRY,
    name: 'Beschwerde',
  },
  {
    id: InquiryType.INQUIRY_TYPE_SAP_CERTIFICATION_INQUIRY,
    name: 'Hauszertifikat',
  },
  {
    id: InquiryType.INQUIRY_TYPE_BFD_CONTACT_INQUIRY,
    name: 'BFD Kontaktanfrage',
  },
  {
    id: InquiryType.INQUIRY_TYPE_CHECKOUT_BOOKING,
    name: 'Online-Buchung',
  },
];

export const InquiryBookerType = {
  INQUIRY_BOOKER_TYPE_COMPANY: 1,
  INQUIRY_BOOKER_TYPE_PRIVATE: 2,
};

export const InquiryBookerTypes = [
  { id: InquiryBookerType.INQUIRY_BOOKER_TYPE_COMPANY, name: 'Firma' },
  {
    id: InquiryBookerType.INQUIRY_BOOKER_TYPE_PRIVATE,
    name: 'Private Person',
  },
];

export const InquirySpamType = {
  INQUIRY_SPAM_TYPE_NOT_CHECKED: 0,
  INQUIRY_SPAM_TYPE_POTENTIAL_SPAM: 1,
  INQUIRY_SPAM_TYPE_SPAM: 2,
  INQUIRY_SPAM_TYPE_NOT_SPAM: 3,
};

export const InquirySpamTypes = [
  {
    id: InquirySpamType.INQUIRY_SPAM_TYPE_NOT_CHECKED,
    name: 'Nicht geprüft',
  },
  {
    id: InquirySpamType.INQUIRY_SPAM_TYPE_POTENTIAL_SPAM,
    name: 'mögl. Spam',
  },
  {
    id: InquirySpamType.INQUIRY_SPAM_TYPE_SPAM,
    name: 'Spam',
  },
  {
    id: InquirySpamType.INQUIRY_SPAM_TYPE_NOT_SPAM,
    name: 'Kein Spam',
  },
];
